import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export interface FeePreset {
  id: string;
  tenantId: string;
  storeId?: string | null;
  name: string;
  type: 'flat' | 'per_hour';
  amount: string;
  description?: string | null;
  sortOrder?: number | null;
  active: boolean;
  createdAt: string;
}

export function listFeePresets(params?: { includeInactive?: boolean }) {
  return apiGet<FeePreset[]>('/api/v1/fee-presets', { params }).then((res) => res.data);
}

export function createFeePreset(body: {
  name: string;
  type?: 'flat' | 'per_hour';
  amount: number;
  description?: string;
  sortOrder?: number;
}) {
  return apiPost<FeePreset, typeof body>('/api/v1/fee-presets', body).then((res) => res.data);
}

export function updateFeePreset(id: string, body: Record<string, unknown>) {
  return apiPatch<FeePreset, Record<string, unknown>>(`/api/v1/fee-presets/${id}`, body).then(
    (res) => res.data,
  );
}

export function deleteFeePreset(id: string) {
  return apiDelete<void>(`/api/v1/fee-presets/${id}`);
}
